module.exports = __webpack_public_path__ + "static/Crowns 2 smile before-7f1642a724d81c995954a41ee39ab7f4.jpg";